import React from 'react'
import Layout from '../../layouts/DefaultLayout'
import { Button, Col, Container, Form, Image, Row } from 'react-bootstrap'
import logo from '../../assets/logo.png'
import { FaEnvelope, FaHome, FaPhone } from 'react-icons/fa';
import { Contact as ContactProps } from '../../@types/Contact';

export default function Contact() {
  const contact: ContactProps[] = [
    {
      key: '1',
      icon: FaHome,
      text: ' Rua Rio de Janeiro, 353, Bairro Brasil, Uberlândia - MG, CEP: 38400-658.',
      href: 'https://goo.gl/maps/nxSzPGiLZP7oyYKHA'
    },
    {
      key: '2',
      icon: FaPhone,
      text: '(34) 9642-3233',
      href: 'whatsapp://send?text=Olá estou tendo algumas dúvidas, poderia me ajudar?&phone=5534996423233'
    },
    {
      key: '3',
      icon: FaEnvelope,
      text: 'contato@uaigraos.com.br',
      href: 'mailto:contato@uaigraos.com.br'
    }
  ]
  return (
    <Layout>
      <Container>
        <Row>
          <Col>
            <div className='d-flex justify-content-center align-items-center mt-5'>
              <Image src={logo} alt='Logo Uai Grãos' fluid />
            </div>
          </Col>
          <Col>
            <div className='d-flex flex-column align-items-start p-5 mt-5'>
              {
                contact.map((item) => (
                  <a href={item.href} target='_blank' rel="noreferrer" className='text-decoration-none text-dark'>
                  <p key={item.key}>
                    <item.icon /> {item.text}
                  </p>
                  </a>
                ))
              }
            </div>
          </Col>
        </Row>
        <Form action="mailto:contato@uaigraos.com.br" method="post" className='my-5'>
          <Row className='mb-3'>
            <Form.Group as={Col} controlId='name' className="mb-3">
              <Form.Label>Nome:</Form.Label>
              <Form.Control type="text" placeholder="Nome:" name='name' required />
            </Form.Group>
            <Form.Group as={Col} controlId='email'>
              <Form.Label>E-Mail:</Form.Label>
              <Form.Control type="email" placeholder="E-Mail:" name='email' required />
            </Form.Group>
          </Row>
          <Form.Group controlId='message' className='mb-3'>
            <Form.Label>Mensagem:</Form.Label>
            <Form.Control placeholder='Mensagem:' name="message" as='textarea' rows={3} required></Form.Control>
          </Form.Group>
          <Button variant="success" type="submit" className='me-3'>
            Enviar
          </Button>
          <Button variant="danger" type="reset">
            Limpar
          </Button>

        </Form>

      </Container>
    </Layout>
  )
}
